<!--  -->
<template>
    <div :class="isMobile?'mlayout':'layout'">
        <div class="navs">
            <div class="nav-item" @click="$router.push('/pano')" @mouseover="animation(1)">
                <div class="imgAnimation"><img v-if="index==1" src="@/assets/images/1_gif.gif" alt=""><img v-else
                        src="@/assets/images/1_img.png" alt=""></div>
                <div class="title"><img src="@/assets/images/1.png" alt=""></div>
            </div>
            <div class="nav-item" @click="$introduce()" @mouseover="animation(2)">
                <div class="imgAnimation"><img v-if="index==2" src="@/assets/images/2_gif.gif" alt=""><img v-else
                        src="@/assets/images/2_img.png" alt=""></div>
                <div class="title"><img src="@/assets/images/2.png" alt=""></div>
            </div>
            <div class="nav-item" @click="$router.push('/scenes')" @mouseover="animation(3)">
                <div class="imgAnimation"><img v-if="index==3" src="@/assets/images/3_gif.gif" alt=""><img v-else
                        src="@/assets/images/3_img.png" alt=""></div>
                <div class="title"><img src="@/assets/images/3.png" alt=""></div>
            </div>
            <div class="nav-item" @click="$router.push('/antiques')" @mouseover="animation(4)">
                <div class="imgAnimation"><img v-if="index==4" src="@/assets/images/4_gif.gif" alt=""><img v-else
                        src="@/assets/images/4_img.png" alt=""></div>
                <div class="title"><img src="@/assets/images/4.png" alt=""></div>
            </div>
        </div>
        <div class="top-icons">
            <div class="icon" @click="$router.push('/')"><img src="@/assets/images/index_button.png" alt=""></div>
        </div>
    </div>
</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';
    import browser from '@/utils/browser.js'
    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {

        },
        data() {
            //这里存放数据
            return {
                isMobile: browser.mobile,
                index: 0,
            };
        },
        //监听属性 类似于data概念
        computed: {

        },
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {
            animation(i) {
                this.index = i;
            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {

        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {

        },
        beforeCreate() {}, //生命周期 - 创建之前
        beforeMount() {}, //生命周期 - 挂载之前
        beforeUpdate() {}, //生命周期 - 更新之前
        updated() {}, //生命周期 - 更新之后
        beforeDestroy() {}, //生命周期 - 销毁之前
        destroyed() {}, //生命周期 - 销毁完成
        activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
    //@import url(); 引入公共css类
    .layout {
        width: 100%;
        height: 100%;
        background: url(../../assets/images/board_bg.jpg)center no-repeat;
        background-size: cover;

        .top-icons {
            position: absolute;
            top: 2vw;
            right: 2vw;

            .icon {
                width: 2.08vw;

            }
        }

        .navs {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            text-align: center;

            .nav-item {
                width: 25%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .title {
                    width: 9.1vw;
                    margin: 0 auto;
                }

                .imgAnimation {
                    width: 18.2vw;
                    height: 18.2vw;
                    margin: 0 auto;

                    img {
                        height: 100%;
                        width: auto;
                    }
                }
            }
        }
    }

    .mlayout {
        position: relative;
        width: 100%;
        height: 100%;
        background: url(../../assets/images/mobile/m-bg.jpg)center no-repeat;
        background-size: 100% auto;

        &:before {
            content: '';
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            background: url(../../assets/images/mobile/board-bg2.png)center no-repeat;
            background-size: 100% 100%;
        }

        .top-icons {
            position: absolute;
            top: 5vw;
            right: 5vw;

            .icon {
                width: 9.7vw;

            }
        }

        .navs {
            position: absolute;
            top: 0;

            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;

            .nav-item {
                width: 100%;
                height: 25%;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .title {
                    width: 21vw;
                    margin: 0 auto;
                }

                .imgAnimation {
                    width: 44vw;

                    margin: 0 auto 2vh;

                    img {
                        height: auto;
                        width: 100%;
                    }
                }
            }
        }
    }
</style>